"use strict";

exports.__esModule = true;
exports.default = sortedIndex;
var _cb = _interopRequireDefault(require("./_cb.js"));
var _getLength = _interopRequireDefault(require("./_getLength.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Use a comparator function to figure out the smallest index at which
// an object should be inserted so as to maintain order. Uses binary search.
function sortedIndex(array, obj, iteratee, context) {
  iteratee = (0, _cb.default)(iteratee, context, 1);
  var value = iteratee(obj);
  var low = 0,
    high = (0, _getLength.default)(array);
  while (low < high) {
    var mid = Math.floor((low + high) / 2);
    if (iteratee(array[mid]) < value) low = mid + 1;else high = mid;
  }
  return low;
}